import React, { useState } from 'react';
import { ChefHat, Truck, X, ArrowRight } from 'lucide-react';
import './RoleActionBanner.css';

interface RoleActionBannerProps {
  userRoles: string[];
  onSellFood: () => void;
  onDeliveryPartner: () => void;
}

const RoleActionBanner: React.FC<RoleActionBannerProps> = ({ userRoles, onSellFood, onDeliveryPartner }) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const isKitchenOwner = userRoles.includes('kitchen_owner');
  const isDeliveryPartner = userRoles.includes('delivery_partner');

  if (!isKitchenOwner && !isDeliveryPartner) return null;

  return (
    <div className={`role-banner ${isKitchenOwner ? 'role-banner--kitchen' : 'role-banner--delivery'}`}>
      <div className="role-banner-inner">
        <div className="role-banner-content">
          {isKitchenOwner && (
            <>
              <span className="role-banner-icon"><ChefHat size={18} /></span>
              <span className="role-banner-text">
                <strong>Ready to earn?</strong> Start listing your home-cooked meals and get orders today.
              </span>
              <button className="role-banner-cta" onClick={onSellFood}>
                Start Cooking
                <ArrowRight size={15} />
              </button>
            </>
          )}
          {!isKitchenOwner && isDeliveryPartner && (
            <>
              <span className="role-banner-icon"><Truck size={18} /></span>
              <span className="role-banner-text">
                <strong>Ready to deliver?</strong> Check available orders and start earning on your schedule.
              </span>
              <button className="role-banner-cta role-banner-cta--delivery" onClick={onDeliveryPartner}>
                View Deliveries
                <ArrowRight size={15} />
              </button>
            </>
          )}
        </div>
        <button className="role-banner-dismiss" onClick={() => setDismissed(true)} aria-label="Dismiss banner">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default RoleActionBanner;
